<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <br>
    <span class="fs-5 fw-bold" style="color:green">(Survey group <i class="fa fa-gear"></i>)</span>
    </div>
        <div class="row" style="padding: 50px 5px 5px 5px">
                      <div class="col-3 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                          <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Keyword</span>
                        </label>
                      </div>
                      <div class="col-6 text-center" style="height: 35px;padding:0px;">
                        <input type="text" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" placeholder="Survey group name..." v-model="keywordToSearch" />
                   
                      </div>
                      <div class="col-3 text-start" style="height: 35px;">
                        <button type="button" @click="getSurveyGroupData();" class="btn btn-success" style="width: 100%;">
                          <i class="fa-solid fa-search"></i>
                        </button>
                      </div>
        </div>      
        <div class="row" style="padding: 3px 5px 0px 5px;height: 60vh;overflow-y: scroll;">
        <table class="table table-striped" style="width:100%;">
          <thead>
            <tr style="background-color:cornflowerblue">
              <th scope="col-2" style="border:1px solid black;padding-bottom:15px;font-size: 12px;">
                No.
              </th>
              <th scope="col-10" style="border:1px solid black;">
                <div class="row">
                  <div class="col-9" style="padding-top:5px;font-size: 12px;">
                    Survey group name
                  </div>
                  <div class="col-3 text-end">
                    <button type="button" class="btn btn-success" @click="clickBtnAddSurveyGroup();">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                  </div>                
              </div>
              </th>
            </tr>
          </thead>
          <tbody >
            <!-- @click="clickRowQuestion(surveyGroup,index+1,surveyGroup.name_la);" -->
            <tr v-for="(surveyGroup, index) in surveyGroupArray" v-bind:key="index"
            @click="clickRowSurveyGroup(index+1,surveyGroup);"
            >
              <td style="border:1px solid black">{{ index+1 }}</td>
              <td class="text-start" style="border:1px solid black;font-size: 12px;">
                {{surveyGroup.name_la}}
                <b>(<span style="color:green">{{surveyGroup.total_question}}</span><i class="fas fa-question"></i>)</b>
                <br>
                <i class="fas fa-clock"></i>{{dateStrFormat(surveyGroup.create_date)}}
                <i class="fa-regular fa-clock"></i>{{dateStrFormat(surveyGroup.last_modify_date)}}
                <br>
                <i v-if="surveyGroup.status&&surveyGroup.status!=0" class="fa-solid fa-check" style="color:green"></i>
                <i v-else class="fa-solid fa-xmark" style="color:red"></i>
                {{surveyGroup.status&&surveyGroup.status!=0?'Active':'Inactive'}}
              </td>
            </tr>
          </tbody>
       </table>
        </div>


        <div class="row text-center" style="padding: 0px 5px 0px 5px">
            <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:100%;" >
              <i class="fas fa-house"></i> Home
            </button>
        </div>


        <!-- MODAL to MODIFY Survey group -->
<div class="modal fade" id="modalSGroupDetail" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
          <b>{{modalSGroupDetailFlagSwicthEdit?'Edit Survey group':(modalSGroupDetailFlagSwicthEdit==null?'Adding Survey group':'Survey group details')}}</b>
        &nbsp;
        <i class="fas fa-pen-to-square" @click="modalSGroupDetailFlagSwicthEdit==true?modalSGroupDetailFlagSwicthEdit=false:modalSGroupDetailFlagSwicthEdit=true"></i>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" :style='!modalSGroupDetailFlagSwicthEdit&&modalSGroupDetailFlagSwicthEdit!=null?{"pointer-events": "none","opacity": "0.4"}: {}'>
        <!-- section1 -->
        <div>  
          <div class="row" style="height:40px;padding-top:5px;font-size: 12px;">
                 <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label ">
                       Number
                    </label>
                  </div>
                  <div class="col-8" style="height: 35px;overflow-y: hidden;">
                  <span class="input-group-text">
                    {{ modalSGroupDetailRowNumber }}
                  </span>
                </div>
          </div>
          <div class="row" style="height:40px;padding-top:5px;font-size: 12px;">
                 <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label ">
                      <i class="fas fa-question"></i> Total Question
                    </label>
                  </div>
                  <div class="col-8" style="height: 35px;overflow-y: hidden;">
                  <span class="input-group-text" style="font-size: 12px;">
                    {{ modalSGroupDetailTotalQuestion }}
                    &nbsp;<a v-if="modalSGroupDetailTotalQuestion!=0" href="javascript:void(0)" @click="viewMoreQuestion();"> View question details</a>
                  </span>
                </div>
          </div>
          
          <div class="row" style="height:40px;padding-top:5px;font-size: 12px;">
                  <div class="col-5 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label ">
                      <i class="fas fa-users"></i> Survey Group Name
                    </label>
                  </div>
                  <div class="col-7" style="height: 35px;overflow-y: hidden;">
                    <input type="text" class="form-control" style="font-size: 12px;width: 100%;height: 35px;" placeholder="Survey group name..." v-model="modalSGroupDetailName">
                  </div>
        </div>  
          <div class="row" style="padding-top: 15px;font-size: 12px;">
            <div class="col-12 text-start">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="modalSGroupDetailStatus" value="true" >
                <label class="form-check-label" for="inlineRadio1" style="font-size: 12px;">Active</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="modalSGroupDetailStatus" value="false">
                <label class="form-check-label" for="inlineRadio2" style="font-size: 12px;">Inactive</label>
              </div>
            </div>
          </div>
         
          </div>
          <hr>
          <!-- section2 Area Province-->
          <!-- <div class="row" style="padding-top: 15px;font-size: 12px;">
                  <div class="col-5 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label ">
                      <i class="fas fa-users"></i> All Province and District
                    </label>
                  </div>
                  <div class="col-2" style="height: 35px;overflow-y: hidden;">
                    <input class="form-check-input" type="checkbox" v-model="modalSGroupDetailIsAllArea" style="width: 20px;height: 20px;">
                  </div>
          </div> -->
          <div style="width: 100%;">
          <span style="font-size: 12px;float: left;"><b>Survey Group Area</b></span>
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 25%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                <input class="form-check-input" type="checkbox" v-model="modalSGroupDetailCheckBoxAll"
                    @change="onChangeCbAllProvince($event)" > All Area
                    
                  </th>
                  <th scope="col" style="width: 75%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>Province</span>
                    <!-- <button type="button" style="float: right;" class="btn btn-success" @click="clickBtnAddProvince();">
                      <i class="fa-solid fa-plus"></i>
                    </button>  -->
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(province, index) in modalSGroupDetailAreaProvinces" v-bind:key="index"
                :style="{'background-color':getRegionColor(province.country_code)}"                
                >
                  <td style="font:12px;border:1px solid black;">
                    <input class="form-check-input" type="checkbox" v-model="province.status">
                    <!-- <i class="fa-solid fa-square-minus" style="color: red;" @click="clickDeleteProvince(index,areaProvince)"></i>  -->
                    {{index+1}}
                  </td>
                  <td class="text-start" style="padding:0px;border:1px solid black;" @click="clickRowProvince(province,index+1);">
                    <span style="font-size: 12px;"> 
                      &nbsp;<b>{{ province.country_code }}</b>{{ ', '+province.name_la+'/'+province.name_en+'/'+province.code}} 
                      <b>{{'('+(province.districts_id?countDistrict(province.districts_id):'0')+'/'+province.all_district+' Districts)'}}</b>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <div class="modal-footer">
        <!-- <button @click="clickBtnDeleteSurveyGroup();" v-if="modalSGroupDetailFlagSwicthEdit&&modalSGroupDetailFlagSwicthEdit!=null" type="button" class="btn btn-danger" data-bs-dismiss="modal">Delete</button> -->
        <button v-if="modalSGroupDetailFlagSwicthEdit||modalSGroupDetailFlagSwicthEdit==null" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button @click="clickSave()" v-if="modalSGroupDetailFlagSwicthEdit||modalSGroupDetailFlagSwicthEdit==null" type="button" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL MODIFY DISTRICT IN PROVINCE -->
<div class="modal fade" id="modalDistrict" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
        <!-- <h7 class="modal-title" id="exampleModalLabel"> -->
          <b>Edit District in {{ modalDistrictProvinceName }}</b>
        <!-- </h7> -->
        &nbsp;
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" >
          <div style="width: 100%;height: 70vh;overflow-y: scroll;">
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 20%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <input class="form-check-input" type="checkbox" v-model="modalDistrictCheckBoxAll" @change=onChangeCbAllDistrict($event)> All District
                  </th>
                  <th scope="col" style="width: 80%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>District</span>                  
                  </th>
                  <!-- <th scope="col" style="width: 10%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    
                  </th> -->
                </tr>
              </thead>
              <tbody >
                <tr v-for="(district, index) in modalDistrictAreaDistricts" v-bind:key="index">
                  <th scope="row" style="font:12px;border:1px solid black;">
                    <input class="form-check-input" type="checkbox" v-model="district.status"> {{index+1}}
                  </th>
                  <td style="padding:0px;border:1px solid black;">
                    {{ district.name_la+'/'+district.name_en }}
                  </td>
                  <!-- <td style="padding:0px;border:1px solid black;">
                    
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" @click="allowDistrictToProvince();">OK</button>
      </div>
    </div>
  </div>
</div>

    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { Modal } from 'bootstrap'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'SurveyPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
        
        questionsData:[],
        modalRowNumber:"",
        surveyGroupArray:[],
        keywordToSearch:"",
        selectedRowSurveyGroup:{},
        modalSGroupDetail:"",
        modalSGroupDetailRowNumber:"",
        modalSGroupDetailName:"",
        modalSGroupDetailStatus:"",
        modalSGroupDetailCreateDate:"",
        modalSGroupDetailLastModifyDate:"",
        modalSGroupDetailFlagSwicthEdit:false,
        // modalSGroupDetailAreaProvince:[],
        modalSGroupDetailCheckBoxAll:false,
        modalSGroupDetailAreaProvinces:[],
        modalDistrict:"",
        modalDistrictProvinceName:"",
        modalDistrictAreaDistricts:[],
        modalDistrictCheckBoxAll:false,
        selectedRowProvince:{},
        allDistrict:[],
        
    };
  },
  mounted:async function() {
    var vm = this;
    vm.getDistricts();
    vm.getSurveyGroupData();
    vm.modalSGroupDetail = new Modal(document.getElementById('modalSGroupDetail'));
    vm.modalDistrict = new Modal(document.getElementById('modalDistrict'));
  },
  methods: {
  getSurveyGroupData: async function(){
    var vm = this;
    var getSurveyGroupResult = await vm.getSurveyGroup(vm.keywordToSearch);
     if(getSurveyGroupResult.status==200&&getSurveyGroupResult.statusText=="OK"){
      vm.surveyGroupArray = getSurveyGroupResult.data.result
     }else{
      vm.surveyGroupArray = [];
     }
   },
   clickBtnAddSurveyGroup: function(){
    var vm = this;
    vm.selectedRowSurveyGroup = {};
    vm.modalSGroupDetailCheckBoxAll = false;
    vm.modalSGroupDetailRowNumber = vm.surveyGroupArray.length+1;
    vm.modalSGroupDetailName = "";
    vm.modalSGroupDetailStatus = true;
    vm.modalSGroupDetailTotalQuestion = 0;
    vm.modalSGroupDetailFlagSwicthEdit = null;
    vm.modalSGroupDetail.show();
    vm.getSurveyGroupAreaProvince();

   },
  clickRowSurveyGroup: function(rowNumber,rowData){
    var vm = this;
    // //Clear checkbox
    vm.modalSGroupDetailCheckBoxAll = false;
    // vm.onChangeCbAllProvince();
    vm.modalSGroupDetailFlagSwicthEdit = false;
    vm.selectedRowSurveyGroup = rowData;
    vm.modalSGroupDetailRowNumber = rowNumber;
    vm.modalSGroupDetailName = rowData.name_la;
    vm.modalSGroupDetailStatus = rowData.status;
    vm.modalSGroupDetailTotalQuestion = rowData.total_question;
    vm.modalSGroupDetail.show();
    vm.getSurveyGroupAreaProvince();

   },
  clickSave:function(){
    var vm = this;
    var validateObject = vm.validateFormSave();
      if(!validateObject.flag){
        vm.$swal.fire('Please prepare information to save!', validateObject.msg, 'error');
      }else{
        vm.$swal.fire({
          title: 'Do you want to save data?',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Send',
          denyButtonText: `Cancel`,
        }).then((result) => {
          if (result.isConfirmed) {
            vm.saveData();
          } 
        });
      }
    },
    validateFormSave:function(){
      var flag = true,
      vm = this,
      msg = "";
      if(!vm.modalSGroupDetailName){
        flag = false;
        msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Survey group name must be typing! </div><br>";
      }
      var selectedProvinceArray = vm.modalSGroupDetailAreaProvinces.filter(item => item.status === true)
      if(selectedProvinceArray.length==0){
        flag = false;
        msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Require, at least 1 province to select! </div><br>";
      }   
      return {"flag":flag,"msg":msg};
    },
    saveData:function(){
      var vm = this;
      vm.showLoading();
      var jsonRequest = {
        surveyGroupId:(vm.selectedRowSurveyGroup.id?vm.selectedRowSurveyGroup.id:null),
        surveyGroupName:vm.modalSGroupDetailName,
        status:vm.modalSGroupDetailStatus,
        surveyGroupArea:vm.modalSGroupDetailAreaProvinces
      }
      axios.post(Global.backendPath+"survey/saveSurveyGroup", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Completed!', '', 'success')
          vm.modalSGroupDetail.hide();
          vm.getSurveyGroupData();
          // vm.resetPage();
        //   vm['questionCType'+custType]=response.data.result;
        }else{
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: 'Error!',
            // footer: '<a href="">Why do I have this issue?</a>'
          })
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
    },
  getSurveyGroupAreaProvince: async function(){
    var vm = this;
    vm.showLoading();
    vm.modalSGroupDetailAreaProvinces = [];
    var jsonRequest = {};
    jsonRequest['surveyGroupId'] = vm.selectedRowSurveyGroup.id;
      return await axios.post(Global.backendPath+"survey/getSGroupAreaProvince", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.modalSGroupDetailAreaProvinces = response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   viewMoreQuestion: function(){
    var vm = this;
    vm.modalSGroupDetail.hide();
    Global.selectedSurveyGroupName = vm.selectedRowSurveyGroup.name_la;
    vm.$router.push("/qandcmanagement");
   },
   countDistrict: function(districtComma){
    var districtArray = districtComma.split(",");
    return districtArray.length;
   },
   getDistricts: async function(){
    var vm = this;
    vm.showLoading();
      return await axios.post(Global.backendPath+"area/getDistricts", {},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.allDistrict=response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   getRegionColor:function(code){
    var color = "";
    if(code=="Capital"){
      color = "#ABEBC6";
    }else if(code=="North 1"){
      color = "#FCF3CF";
    }else if(code=="North 2"){
      color = "#EAEDED";
    }else if(code=="Central"){
      color = "#D6EAF8";
    }else{
      color = "#FADBD8";
    }
    return color;
   },
   onChangeCbAllProvince(){
    var vm = this;
        if(vm.modalSGroupDetailCheckBoxAll){
          for(var idx=0;idx<vm.modalSGroupDetailAreaProvinces.length;idx++){
            var province = vm.modalSGroupDetailAreaProvinces[idx];
            province.status=true;
            var districtArray = vm.allDistrict.filter(item => item.province_id == province.province_id);
            var districtIdComma = "";
              for(var index=0;index<districtArray.length;index++){
                var district = districtArray[index];
                districtIdComma+=(districtIdComma!=""?",":"")+district.id;
              }
              province.districts_id = districtIdComma; 
          }
        }else{
          for(var idx2=0;idx2<vm.modalSGroupDetailAreaProvinces.length;idx2++){
            var province2 = vm.modalSGroupDetailAreaProvinces[idx2];
            province2.status=false;
            province2.districts_id=""
          }
        }
    },
    clickRowProvince: function(rowData,itemNumber){
      var vm = this;
      try{
        if(!rowData.status){
          vm.$swal.fire('Warning message!', "Please select item #"+itemNumber+" ("+rowData.name_la+"/"+rowData.name_en+") before edit district!", 'error');
        }else{
          vm.modalDistrictCheckBoxAll = false;
          vm.selectedRowProvince = rowData;
          vm.modalDistrictProvinceName = rowData.name_la+'/'+rowData.name_en;
          vm.modalDistrictAreaDistricts = vm.allDistrict.filter(item => item.province_id == rowData.province_id);
          var districtIdArray = (rowData.districts_id?rowData.districts_id.split(","):[]);
          for(var idx=0;idx<districtIdArray.length;idx++){
            var districtId = districtIdArray[idx];
            var districtArray = vm.modalDistrictAreaDistricts.filter(item => item.id == districtId);
            if(districtArray.length>0){
              districtArray[0].status = true;
            }
          }
          vm.modalDistrict.show();
        }
      
      }catch(error){
        console.log(error);
      }
      
    },
    allowDistrictToProvince: function(){
      var vm = this;
      var selectedDistrict = vm.modalDistrictAreaDistricts.filter(item => item.status === true);
      if(selectedDistrict.length==0){
        vm.$swal.fire('Warning message!', "Require, at least 1 district to select!", 'error');
      }else{
        var districtIdComma="";
        for(var idx=0;idx<vm.modalDistrictAreaDistricts.length;idx++){
          var district = vm.modalDistrictAreaDistricts[idx];
          if(district.status){
            districtIdComma+=(districtIdComma!=""?",":"")+district.id;
          }
        }
        vm.selectedRowProvince.districts_id = districtIdComma;
        vm.modalDistrict.hide();
      }
      
    },
    onChangeCbAllDistrict(){
    var vm = this;
        if(vm.modalDistrictCheckBoxAll){
          vm.modalDistrictAreaDistricts.forEach(district => district.status=true);
        }else{
          vm.modalDistrictAreaDistricts.forEach(district => district.status=false);
        }
    },
    clickBtnDeleteSurveyGroup: function(){
      var vm = this;
      vm.$swal.fire({
        title: 'Do you want to delete this Survey group ('+vm.modalSGroupDetailName+')?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          vm.deleteSurveyGroupData();

        }
      });

    },
    deleteSurveyGroupData: async function(){
      var vm = this;
      vm.showLoading();
        return await axios.post(Global.backendPath+"survey/deleteSurveyGroup", {"surveyGroupId" : vm.selectedRowSurveyGroup.id},
        {
              headers: {
              "Authorization": localStorage.getItem("token")
              }
        })
        .then((response) => {
          vm.hideLoading();
          if(response.status==200&&response.statusText=="OK"){
            vm.$swal.fire('Delete this survey group has been completed!', '', 'success');
            vm.getSurveyGroupData();
          }else{
            vm.$swal.fire("Can't deleteSurveyGroupData", '', 'error');
          }
        }).catch((error) => {
          vm.hideLoading();
          console.log(error);
          vm.$swal.fire("Can't deleteSurveyGroupData", '', 'error');
          vm.isTokenExpire(error);
        });
    }
 

},
};
</script>
